export default "__VITE_ASSET__bd4cc77a__"